<!DOCTYPE html>
<button #button [disabled]="isDisabled" (click)="onClick()">
  {{ buttonText }}
  <div class="progress-bar" [style.width.%]="progress"></div>
</button>
